import { Routes, Route, Navigate } from "react-router-dom";
// screens
import { BuscarConvocatoria } from "../screens/Usuario/BuscarConvocatoria/buscar-convocatoria.view";
import { Postulacion } from "../screens/Usuario/Postulacion/Postulacion.view";
import { AgregarParticipante } from "../screens/Usuario/AgregarParticipante/AgregarParticipante";
import { PostulacionesUsuario } from "../screens/Usuario/MisPostulaciones/PostulacionesUsuario";
import { MenuJurado } from "../screens/Jurados/InscribirHojaJurados/Inscribirhojajurados";
import { RegistrarJurado } from "../screens/Jurados/RegistrarJurado/RegistrarJurado";
import { AgregarExperiencia } from "../screens/Jurados/AgregarExperiencia/AgregarExperiencia.view";
import { Categorias } from "../screens/Jurados/Categorias/categorias.view";
import { EduacionFormal } from "../screens/Jurados/EducacionFormal/educacion-formal.view";
import { Publicaciones } from "../screens/Jurados/Publicaciones/Publicaciones";
import { DocumentosAdministrativosJurado } from "../screens/Jurados/DocumentosAdministrativosJurado/DocumentosAdministrativosJurado";
import { Reconocimientos } from "../screens/Jurados/Reconocimientos/Reconocimientos";
import { AgregarExperienciaProfesional } from "../screens/Jurados/AgregarExperienciaProfesional/AgregarExperienciaProfesional";
import { EducacionNoFormal } from "../screens/Jurados/EducacionNoFormal/educacion-noformal.view";
import { RegistrarUsuario } from '../screens/Usuario/RegistrarUsuario/index'
import { EstadosFormulariosJurados } from "../screens/Jurados/EstadosFormulariosJurados/EstadosFormulariosJurados";
import { CambiarContrasena } from "../screens/Usuario/RegistrarUsuario/CambiarContrasena/index";
import { RegistroExitoso } from "../screens/Usuario/RegistrarUsuario/RegistroExitoso/RegistroExitoso";
import { InscribirJurado } from '../screens/Jurados/Regiterform/inscribirJurado';
import NotificacionesUsuario from "../screens/Usuario/CentroNotificaciones/NotificacionesUsuario";
import ValidateAccessMiddleware from "../middlewares/ValidateAccessMiddleware";

export const UserRoute = () => {


  return (
    <>
      <ValidateAccessMiddleware />
      <Routes>
        <Route path="/" element={<BuscarConvocatoria />} />
        <Route path="/postulacion" element={<Postulacion />} />
        <Route
          path="/Seleccionarrol"
          element={<Navigate to="/usuario/postulacion?paso=perfil" replace />}
        />
        <Route
          path="/Personanatural"
          element={<Navigate to="/usuario/postulacion?paso=perfil" replace />}
        />
        <Route
          path="/Personajuridica"
          element={<Navigate to="/usuario/postulacion?paso=perfil" replace />}
        />
        <Route
          path="/Grupoconformado"
          element={<Navigate to="/usuario/postulacion?paso=perfil" replace />}
        />
        <Route path="/agregarParticipante" element={<AgregarParticipante />} />
        <Route
          path="/seleccionarCategoria"
          element={<Navigate to="/usuario/postulacion?paso=propuesta" replace />}
        />
        <Route
          path="/Documentostecnicos"
          element={<Navigate to="/usuario/postulacion?paso=propuesta" replace />}
        />
        <Route
          path="/Documentosadministrativos"
          element={<Navigate to="/usuario/postulacion?paso=propuesta" replace />}
        />
        <Route
          path="/Agregarurl"
          element={<Navigate to="/usuario/postulacion?paso=cierre" replace />}
        />
        <Route path="/Mispostulaciones" element={<PostulacionesUsuario />} />
        <Route path="/MenuJurado" element={<MenuJurado />} />
        <Route path="/Inscribirhojadevida" element={<InscribirJurado />} />
        <Route path="/categorias" element={<Categorias />} />
        <Route path="/categorias/:estadoFormulario" element={<Categorias />} />
        <Route path="/educacionFormal" element={<EduacionFormal />} />
        <Route path="/educacionFormal/:estadoFormulario" element={<EduacionFormal />} />
        <Route path="/educacionNoFormal" element={<EducacionNoFormal />} />
        <Route path="/educacionNoFormal/:estadoFormulario" element={<EducacionNoFormal />} />
        <Route path="/registrarJurado/:estadoFormulario" element={<RegistrarJurado />} />
        <Route path="/Registrarjurado">
          <Route path="" element={<RegistrarJurado />} />
          <Route path=":registrarJurado" element={<RegistrarJurado />} />
        </Route>
        
        <Route path="/DocumentosadministrativosJurado" element={<DocumentosAdministrativosJurado />} />
        <Route path="/DocumentosadministrativosJurado/:estadoFormulario" element={<DocumentosAdministrativosJurado />} />
        <Route path="/Reconocimientos" element={<Reconocimientos />} />
        <Route path="/Reconocimientos/:estadoFormulario" element={<Reconocimientos />} />
        <Route path="/Publicaciones" element={<Publicaciones />} />
        <Route path="/Publicaciones/:estadoFormulario" element={<Publicaciones />} />
        <Route path="/agregarExperienciaJurado" element={<AgregarExperiencia />} />
        <Route path="/agregarExperienciaJurado/:estadoFormulario" element={<AgregarExperiencia />} />
        <Route path="/agregarExperienciaProfesionalJurado" element={<AgregarExperienciaProfesional />} />
        <Route path="/agregarExperienciaProfesionalJurado/:estadoFormulario" element={<AgregarExperienciaProfesional />} />
        <Route path="/registrarUsuario" element={<RegistrarUsuario />} />
        <Route path="/estadosFormulario" element={<EstadosFormulariosJurados />} />
        <Route path="/CambiarContrasena" element={<CambiarContrasena />} />
        <Route path="/RegistroExitoso" element={<RegistroExitoso />} />
        <Route path="/notificacionesUsuario" element={<NotificacionesUsuario />} />
      </Routes>
    </>
  );
};
